// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewCustomer_otr .inputs_otr .input_otr .theme_input {
    margin-bottom: 12px !important;
}

.NewCustomer_otr .customer_note {
    padding-top: 15px;
}

.error-border {
    border: 1px solid red;
}

.AddressStep_otr .customer_desc {
    font-family: 'Poppins', sans-serif !important;
    font-weight: 700;
    color: var(--desc-color);
    letter-spacing: 0.01071em;
}
/* 
.AddressStep_otr .address_input_otr .label_text,
.AddressStep_otr .address_inputs_otr .label_text {
    display: none;
} */

.AddressStep_otr .or_text_otr {
    display: flex;
    align-items: center;
    gap: 10px;
}

.AddressStep_otr .or_text_otr hr {
    width: 100%;
    flex: 1 1;
    height: 1px;
    background: var(--primary-color);
    border: none;
}

.AddressStep_otr .or_text_otr .or_text {
    font-size: 16px;
    line-height: 24px;
    color: var(--dark-text-color);
    font-family: Verdana, sans-serif !important;
}

.AddressStep_otr .address_input_otr .input_otr{
    margin-bottom: 24px;
}
.AddressStep_otr .address_inputs_otr .input_otr .theme_input {
    margin-bottom: 5px !important;
}

.StateSelect_otr {
    padding-top: 9px;
    margin-bottom: 12px;
}

.StateSelect_otr .ant-select {
    width: 100%;
    height: 54px !important;
}

.StateSelect_otr .ant-select .ant-select-selector {
    padding: 14px 14px 12px 14px !important;
}

.StateSelect_otr .ant-select .ant-select-selection-placeholder,
.StateSelect_otr .ant-select .ant-select-selection-item {
    font-size: 16px;
    line-height: 24px;
}

.ant-select-dropdown .ant-select-item {
    padding: 14px 14px 12px 14px !important;
    height: 52px !important;
}

.AddressStep_otr .theme_checkbox {
    margin: 12px 0 24px 12px;
}

.address_btn {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--dark-text-color);
    border: 1px solid var(--primary-color) !important;
    background-color: var(--primary-color) !important;
    padding: 8px 12px;
    height: auto !important;
    border-radius: 50px;
    text-transform: uppercase;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    -ms-border-radius: 50px;
    -o-border-radius: 50px;
}

.address_btn .btn_text {
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    color: var(--white-color) !important;
}

.address_btn.disabled {
    opacity: 0.5;
    cursor: auto !important;
}

.theme_checkbox {
    display: flex;
    align-items: center;
    gap: 12px;
}
.theme_checkbox::after {
    display: none;
}
.theme_checkbox span:nth-child(2) {
    font-size: 16px;
    font-family: Verdana, sans-serif !important;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.00938em;
    color: var(--black-color);
    padding: 0;
}
.theme_checkbox .ant-checkbox-input,
.theme_checkbox .ant-checkbox-inner {
    width: 20px !important;
    height: 20px !important;
}
:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner,
.theme_checkbox .ant-checkbox-inner {
    border: 3px solid var(--primary-color) !important;
}
:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner,
:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox-checked .ant-checkbox-inner,
.ant-checkbox-checked .ant-checkbox-inner {
    background-color: var(--primary-color) !important;
}
.theme_checkbox .ant-checkbox-inner::after {
    top: 56% !important;
    inset-inline-start: 18% !important;
    transform: rotate(45deg) scale(1.4) translate(-58%, -52%) !important;
    -webkit-transform: rotate(45deg) scale(1.4) translate(-58%, -52%) !important;
    -moz-transform: rotate(45deg) scale(1.4) translate(-58%, -52%) !important;
    -ms-transform: rotate(45deg) scale(1.4) translate(-58%, -52%) !important;
    -o-transform: rotate(45deg) scale(1.4) translate(-58%, -52%) !important;
}

.editor-content {
	margin-top: 10px;
	word-break: normal;
	line-height: 1.5;
}

.editor-content p {
	margin-bottom: 12px;
	display: inline;
}

.editor-content a {
	text-decoration: none;
	display: inline;
	word-break: normal;
}

.editor-content a:hover {
	text-decoration: underline;
}

.editor-content br {
	display: block  !important;;
	margin: 8px 0  !important;;
	content: "";
}

.customer_note {
	display: block;
	font-weight: 600  !important;;
	margin-bottom: 8px  !important;;
}

.note_text {
	display: block  !important;;
	margin-top: 8px  !important;;
	color: var(--desc-color)  !important;;
}

.customer_note .note_text {
    font-family: Verdana, sans-serif !important;
    font-weight: 100 !important;
    margin-left: 4px;
}




.tooltip-trigger {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    cursor: pointer;
    color: var(--primary-color);
  }
  
  .tooltip-trigger svg {
    transition: transform 0.2s ease;
  }
  
  .tooltip-trigger:hover svg {
    transform: scale(1.1);
  }
  
  .address_btn .tooltip-trigger {
    display: inline-flex;
    align-items: center;
    margin-left: 8px;
    cursor: pointer;
    color: var(--white-color);
  }
  
  .address_btn .tooltip-trigger svg {
    transition: transform 0.2s ease;
  }
  
  .address_btn .tooltip-trigger:hover svg {
    transform: scale(1.1);
  }
  
  .address_btn.disabled .tooltip-trigger {
    opacity: 0.7;
  }
  
.theme_input .ant-form-item-explain-error {
    font-size: 10px;
}

.inputs_otr .ant-form-item {
    margin-bottom: 20px;
}

.error-border .ant-input {
    border-color: #F84771 !important;
}
  `, "",{"version":3,"sources":["webpack://./src/Components/ClientInfo/NewCustomer/NewCustomer.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6CAA6C;IAC7C,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;;;;GAIG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,SAAO;IACP,WAAW;IACX,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;;IAEI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;IAC7B,iDAAiD;IACjD,iDAAiD;IACjD,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,2CAA2C;IAC3C,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,UAAU;AACd;AACA;;IAEI,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;;IAEI,iDAAiD;AACrD;AACA;;;IAGI,iDAAiD;AACrD;AACA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,oEAAoE;IACpE,4EAA4E;IAC5E,yEAAyE;IACzE,wEAAwE;IACxE,uEAAuE;AAC3E;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;CAC1B,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,4BAA4B;CAC5B,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,oCAAoC;AACrC;;AAEA;IACI,2CAA2C;IAC3C,2BAA2B;IAC3B,gBAAgB;AACpB;;;;;AAKA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;AAEF;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC","sourcesContent":[".NewCustomer_otr .inputs_otr .input_otr .theme_input {\n    margin-bottom: 12px !important;\n}\n\n.NewCustomer_otr .customer_note {\n    padding-top: 15px;\n}\n\n.error-border {\n    border: 1px solid red;\n}\n\n.AddressStep_otr .customer_desc {\n    font-family: 'Poppins', sans-serif !important;\n    font-weight: 700;\n    color: var(--desc-color);\n    letter-spacing: 0.01071em;\n}\n/* \n.AddressStep_otr .address_input_otr .label_text,\n.AddressStep_otr .address_inputs_otr .label_text {\n    display: none;\n} */\n\n.AddressStep_otr .or_text_otr {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.AddressStep_otr .or_text_otr hr {\n    width: 100%;\n    flex: 1;\n    height: 1px;\n    background: var(--primary-color);\n    border: none;\n}\n\n.AddressStep_otr .or_text_otr .or_text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--dark-text-color);\n    font-family: Verdana, sans-serif !important;\n}\n\n.AddressStep_otr .address_input_otr .input_otr{\n    margin-bottom: 24px;\n}\n.AddressStep_otr .address_inputs_otr .input_otr .theme_input {\n    margin-bottom: 5px !important;\n}\n\n.StateSelect_otr {\n    padding-top: 9px;\n    margin-bottom: 12px;\n}\n\n.StateSelect_otr .ant-select {\n    width: 100%;\n    height: 54px !important;\n}\n\n.StateSelect_otr .ant-select .ant-select-selector {\n    padding: 14px 14px 12px 14px !important;\n}\n\n.StateSelect_otr .ant-select .ant-select-selection-placeholder,\n.StateSelect_otr .ant-select .ant-select-selection-item {\n    font-size: 16px;\n    line-height: 24px;\n}\n\n.ant-select-dropdown .ant-select-item {\n    padding: 14px 14px 12px 14px !important;\n    height: 52px !important;\n}\n\n.AddressStep_otr .theme_checkbox {\n    margin: 12px 0 24px 12px;\n}\n\n.address_btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--dark-text-color);\n    border: 1px solid var(--primary-color) !important;\n    background-color: var(--primary-color) !important;\n    padding: 8px 12px;\n    height: auto !important;\n    border-radius: 50px;\n    text-transform: uppercase;\n    -webkit-border-radius: 50px;\n    -moz-border-radius: 50px;\n    -ms-border-radius: 50px;\n    -o-border-radius: 50px;\n}\n\n.address_btn .btn_text {\n    font-size: 14px;\n    line-height: 16px;\n    font-weight: 600;\n    font-family: 'Poppins', sans-serif;\n    color: var(--white-color) !important;\n}\n\n.address_btn.disabled {\n    opacity: 0.5;\n    cursor: auto !important;\n}\n\n.theme_checkbox {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n.theme_checkbox::after {\n    display: none;\n}\n.theme_checkbox span:nth-child(2) {\n    font-size: 16px;\n    font-family: Verdana, sans-serif !important;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 0.00938em;\n    color: var(--black-color);\n    padding: 0;\n}\n.theme_checkbox .ant-checkbox-input,\n.theme_checkbox .ant-checkbox-inner {\n    width: 20px !important;\n    height: 20px !important;\n}\n:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner,\n.theme_checkbox .ant-checkbox-inner {\n    border: 3px solid var(--primary-color) !important;\n}\n:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner,\n:where(.css-dev-only-do-not-override-6j9yrn).ant-checkbox-checked .ant-checkbox-inner,\n.ant-checkbox-checked .ant-checkbox-inner {\n    background-color: var(--primary-color) !important;\n}\n.theme_checkbox .ant-checkbox-inner::after {\n    top: 56% !important;\n    inset-inline-start: 18% !important;\n    transform: rotate(45deg) scale(1.4) translate(-58%, -52%) !important;\n    -webkit-transform: rotate(45deg) scale(1.4) translate(-58%, -52%) !important;\n    -moz-transform: rotate(45deg) scale(1.4) translate(-58%, -52%) !important;\n    -ms-transform: rotate(45deg) scale(1.4) translate(-58%, -52%) !important;\n    -o-transform: rotate(45deg) scale(1.4) translate(-58%, -52%) !important;\n}\n\n.editor-content {\n\tmargin-top: 10px;\n\tword-break: normal;\n\tline-height: 1.5;\n}\n\n.editor-content p {\n\tmargin-bottom: 12px;\n\tdisplay: inline;\n}\n\n.editor-content a {\n\ttext-decoration: none;\n\tdisplay: inline;\n\tword-break: normal;\n}\n\n.editor-content a:hover {\n\ttext-decoration: underline;\n}\n\n.editor-content br {\n\tdisplay: block  !important;;\n\tmargin: 8px 0  !important;;\n\tcontent: \"\";\n}\n\n.customer_note {\n\tdisplay: block;\n\tfont-weight: 600  !important;;\n\tmargin-bottom: 8px  !important;;\n}\n\n.note_text {\n\tdisplay: block  !important;;\n\tmargin-top: 8px  !important;;\n\tcolor: var(--desc-color)  !important;;\n}\n\n.customer_note .note_text {\n    font-family: Verdana, sans-serif !important;\n    font-weight: 100 !important;\n    margin-left: 4px;\n}\n\n\n\n\n.tooltip-trigger {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 8px;\n    cursor: pointer;\n    color: var(--primary-color);\n  }\n  \n  .tooltip-trigger svg {\n    transition: transform 0.2s ease;\n  }\n  \n  .tooltip-trigger:hover svg {\n    transform: scale(1.1);\n  }\n  \n  .address_btn .tooltip-trigger {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 8px;\n    cursor: pointer;\n    color: var(--white-color);\n  }\n  \n  .address_btn .tooltip-trigger svg {\n    transition: transform 0.2s ease;\n  }\n  \n  .address_btn .tooltip-trigger:hover svg {\n    transform: scale(1.1);\n  }\n  \n  .address_btn.disabled .tooltip-trigger {\n    opacity: 0.7;\n  }\n  \n.theme_input .ant-form-item-explain-error {\n    font-size: 10px;\n}\n\n.inputs_otr .ant-form-item {\n    margin-bottom: 20px;\n}\n\n.error-border .ant-input {\n    border-color: #F84771 !important;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
